export default __webpack_public_path__ + "static/amonite-fd88ee826917e569795b03fc78303b04.svg";